<h3>{{ 'sez.business-reg-tab2.shareholder-address' | translate }}</h3>
<form  nz-form [formGroup]="addressForm" [nzLayout]="'vertical'">
    <!-- <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"> -->
        <div nz-row>
          <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
            <nz-form-item>
              <nz-form-control [nzErrorTip]="'validation.required-field' | translate">
                <input nz-input formControlName="line1"
                  placeholder="{{ 'sez.business-reg-tab2.shareholder-addressLine1' | translate }}">
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
            <nz-form-item>
              <nz-form-control [nzErrorTip]="'validation.required-field' | translate">
                <input nz-input formControlName="line2"
                  placeholder="{{ 'sez.business-reg-tab2.shareholder-addressLine2' | translate }}">
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div nz-row>
          <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
            <nz-form-item class="pr-md">
              <nz-form-control [nzErrorTip]="'validation.required-field' | translate">
                <input formControlName="line3" nz-input
                  placeholder="{{ 'sez.business-reg-tab2.shareholder-ZIPPostalPOBox' | translate }}" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
            <nz-form-item class="pl-lg">
              <nz-form-control [nzErrorTip]="'validation.required-field' | translate">
                <nz-select id="countrytype" [nzSize]="'default'" nzShowSearch formControlName="country" nzAllowClear
                  [nzPlaceHolder]="'Select Country'">
                  <nz-option *ngFor="let option of listNationality" [nzLabel]="option.label" [nzValue]="option.code">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div nz-row>
          <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
            <nz-form-item class="pr-md">
              <nz-form-control [nzErrorTip]="'validation.required-field' | translate">
                <nz-select id="statetype" [nzSize]="'default'" nzShowSearch formControlName="state" nzAllowClear
                  [nzPlaceHolder]="'Select State'">
                  <nz-option *ngFor="let option of listStates" [nzLabel]="option.label" [nzValue]="option.code">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
</form>